__turbopack_context__.v({
  "brand": "Welcome-module__vLMQda__brand",
  "card": "Welcome-module__vLMQda__card",
  "error": "Welcome-module__vLMQda__error",
  "field": "Welcome-module__vLMQda__field",
  "input": "Welcome-module__vLMQda__input",
  "label": "Welcome-module__vLMQda__label",
  "shell": "Welcome-module__vLMQda__shell",
  "spin": "Welcome-module__vLMQda__spin",
  "spinner": "Welcome-module__vLMQda__spinner",
  "submit": "Welcome-module__vLMQda__submit",
  "subtitle": "Welcome-module__vLMQda__subtitle",
  "title": "Welcome-module__vLMQda__title",
  "toggle": "Welcome-module__vLMQda__toggle",
});
